import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddColumnAfter = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.75 8.24994C14.0261 8.24994 14.25 8.02608 14.25 7.74994C14.25 7.4738 14.0261 7.24994 13.75 7.24994L11.25 7.24994L11.25 4.74994C11.25 4.4738 11.0261 4.24994 10.75 4.24994C10.4739 4.24994 10.25 4.4738 10.25 4.74994V7.24994H7.75C7.47386 7.24994 7.25 7.4738 7.25 7.74994C7.25 8.02608 7.47386 8.24994 7.75 8.24994H10.25L10.25 10.7499C10.25 11.0261 10.4739 11.2499 10.75 11.2499C11.0261 11.2499 11.25 11.0261 11.25 10.7499L11.25 8.24994H13.75ZM4.75 4.25V2.25L2.75 2.25V4.25H4.75ZM5.75 4.25V5.25L5.75 7.25V8.25V10.25V11.25V13.25C5.75 13.8023 5.30229 14.25 4.75 14.25H2.75C2.19772 14.25 1.75 13.8023 1.75 13.25V11.25V10.25V8.25V7.25L1.75 5.25V4.25V2.25C1.75 1.69772 2.19772 1.25 2.75 1.25L4.75 1.25C5.30229 1.25 5.75 1.69772 5.75 2.25V4.25ZM2.75 11.25V13.25H4.75V11.25H2.75ZM4.75 10.25H2.75V8.25H4.75V10.25ZM4.75 5.25L4.75 7.25H2.75L2.75 5.25H4.75Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default AddColumnAfter
